document.addEventListener('DOMContentLoaded', () => {
  console.log('New complementary products script loaded');

  // Get settings and URL from the window object
  const productsToShow = window.recommendationsSettings.productsToShow;
  const productsPerPage = window.recommendationsSettings.productsPerPage;
  const recommendationsUrl = window.recommendationsSettings.recommendationsUrl;
  const productsGrid = document.querySelector('.new-complementary-products-grid');
  const loadMoreButton = document.getElementById('new-load-more-button');

  let products = [];
  let productsDisplayed = 0;

  // Fetch product recommendations from the URL
  function fetchProductRecommendations() {
    console.log('Fetching product recommendations from URL:', recommendationsUrl);

    fetch(recommendationsUrl, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('Product recommendations response:', data);
      
      // Check if recommendations are available
      if (data && data.products && data.products.length > 0) {
        products = data.products;
        console.log('Fetched products:', products);

        // Initialize product display
        initProductDisplay();
      } else {
        console.error('No products found in recommendations');
      }
    })
    .catch(error => {
      console.error('Error fetching product recommendations:', error);
    });
  }

// Render product cards
function renderProducts(productsToRender) {
  // Create a new row container for this batch of products
  const rowContainer = document.createElement('div');
  rowContainer.classList.add('product-row');

  productsToRender.forEach(product => {
    const productCard = document.createElement('div');
    productCard.classList.add('product-card');
    productCard.innerHTML = `
      <a href="${product.url}">
        <img src="${product.featured_image}" alt="${product.title}" class="product-image" />
        <h4 class="product-title">${product.title}</h4>
        <p class="product-price">${formatMoney(product.price)}</p>
      </a>
    `;
    rowContainer.appendChild(productCard);
  });

  // Append the row container to the products grid
  productsGrid.appendChild(rowContainer);
}


// Function to handle "Load More" button clicks
function handleLoadMore() {
  // Determine the number of products to add in this batch
  const nextBatchSize = Math.min(productsPerPage, products.length - productsDisplayed);
  const nextProducts = products.slice(productsDisplayed, productsDisplayed + nextBatchSize);

  // Render the batch of products
  renderProducts(nextProducts);
  productsDisplayed += nextBatchSize;

  // Hide the "Load More" button if all products are displayed
  if (productsDisplayed >= products.length) {
    loadMoreButton.style.display = 'none';
  }
}

// Initial render of products
function initProductDisplay() {
  if (products.length > 0) {
    const initialProducts = products.slice(0, productsPerPage);
    renderProducts(initialProducts);
    productsDisplayed += initialProducts.length;

    // Show the "Load More" button if there are more products to display
    if (products.length > productsDisplayed) {
      loadMoreButton.style.display = 'block';
    } else {
      loadMoreButton.style.display = 'none';
    }
  }
}


  // Fetch recommendations on page load
  fetchProductRecommendations();

  // Set up "Load More" button click handler
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', handleLoadMore);
  }
});

// Utility function to format prices (modify as needed for your currency formatting)
function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}
